<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="
			(setDialogHide) => {
				handleCloseDialog(setDialogHide, isFormDirty);
			}
		"
		class="custom-dialog"
		:visible.sync="isPopupActiveLocal"
	>
		<div slot="title">
			<h4 class="uppercase font-bold block text-xl w-full">CHI TIẾT KHỚP LỆNH #{{id}}</h4>
			<!-- <p class="text-base text-black font-medium">{{ data.device ? data.device.name : "" }}</p> -->
		</div>
		<PerfectScrollbar ref="formScrollBar" class="scroll-area--data-list" :settings="settings">
			<div class="p-6" v-if="isPopupActiveLocal">
				<div class="mb-5">
					<label for class="text-base vs-input--label"> Phụ phẩm <span class="text-danger">*</span>: </label>
					<v-select
						:clearable="false"
						class="border-none w-full"
						:placeholder="`Chọn phụ phẩm`"
						v-model="product"
						name="product"
						:options="$store.state.moduleProduct.products"
						:reduce="(p) => p.id"
						label="name"
						:data-vv-as="'Phụ phẩm'"
						v-validate="'required'"
						required="true"
					/>
					<span class="text-danger text-sm break-normal" v-show="errors.has('product')">{{ errors.first("product") }}</span>
				</div>
				<!-- NAME -->
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Khối lượng (kg)
						<span class="text-danger">*</span>:
					</label>
					<cbs-input type="number" v-model="quantity" class="w-full" name="quantity" :data-vv-as="'Khối lượng'" :placeholder="`${$t('Input')} ${'Khối lượng'}`" v-validate="'required'" />
					<span class="text-danger text-sm break-normal" v-show="errors.has('quantity')">{{ errors.first("quantity") }}</span>
				</div>
				<!-- NAME -->
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Đơn giá (đ)
						<span class="text-danger">*</span>:
					</label>
					<cbs-input type="number" v-model="price" class="w-full" name="price" :data-vv-as="'Đơn giá'" :placeholder="`${$t('Input')} ${'Đơn giá'}`" v-validate="'required'" />
					<span class="text-danger text-sm break-normal" v-show="errors.has('price')">{{ errors.first("price") }}</span>
				</div>
				<div class="mb-5" v-if="data.type==2">
					<label for class="text-base vs-input--label"> Chọn nhà cung cấp <span class="text-danger">*</span>: </label>
					<v-select
						:clearable="false"
						class="border-none w-full"
						:placeholder="`Chọn nhà cung cấp`"
						v-model="supplier"
						name="supplier"
						:options="$store.state.moduleProduct.suppliers"
						:reduce="(p) => p.id"
						label="name"
						:data-vv-as="'Nhà cung cấp'"
						v-validate="'required'"
						required="true"
					/>
					<span class="text-danger text-sm break-normal" v-show="errors.has('supplier')">{{ errors.first("supplier") }}</span>
				</div>
				<div v-if="supplier==0 && data.type==2">
					<!-- NAME -->
					<div class="mb-5">
						<label for class="text-base vs-input--label"> Tên nhà cung cấp: </label>
						<cbs-input v-model="supplier_name" class="w-full" name="supplier_name" :data-vv-as="'Tên nhà cung cấp'" :placeholder="`${$t('Input')} ${'Tên nhà cung cấp'}`" />
						<span class="text-danger text-sm break-normal" v-show="errors.has('supplier_name')">{{ errors.first("supplier_name") }}</span>
					</div>
					<!-- NAME -->
					<div class="mb-5" v-if="data.type == 2">
						<label for class="text-base vs-input--label"> Điện thoại NCC: </label>
						<cbs-input v-model="supper_phone" class="w-full" name="supper_phone" :data-vv-as="'Điện thoại NCC'" :placeholder="`${$t('Input')} ${'Điện thoại NCC'}`" />
						<span class="text-danger text-sm break-normal" v-show="errors.has('supper_phone')">{{ errors.first("supper_phone") }}</span>
					</div>
					<!-- NAME -->
					<div class="mb-5" v-if="data.type == 2">
						<label for class="text-base vs-input--label"> Mã số thuế NCC: </label>
						<cbs-input v-model="supper_mst" class="w-full" name="supper_mst" :data-vv-as="'Mã số thuế NCC'" :placeholder="`${$t('Input')} ${'Mã số thuế NCC'}`" />
						<span class="text-danger text-sm break-normal" v-show="errors.has('supper_mst')">{{ errors.first("supper_mst") }}</span>
					</div>
					<!-- NAME -->
					<div class="mb-5" v-if="data.type == 2">
						<label for class="text-base vs-input--label"> Số tài khoản: </label>
						<cbs-input v-model="supplier_bankaccount" class="w-full" name="supplier_bankaccount" :data-vv-as="'Số tài khoản'" :placeholder="`${$t('Input')} ${'Số tài khoản'}`" />
						<span class="text-danger text-sm break-normal" v-show="errors.has('supplier_bankaccount')">{{ errors.first("supplier_bankaccount") }}</span>
					</div>
					<!-- NAME -->
					<div class="mb-5" v-if="data.type == 2">
						<label for class="text-base vs-input--label"> Ngân hàng: </label>
						<cbs-input v-model="supplier_bankname" class="w-full" name="supplier_bankname" :data-vv-as="'Ngân hàng'" :placeholder="`${$t('Input')} ${'Ngân hàng'}`" />
						<span class="text-danger text-sm break-normal" v-show="errors.has('supplier_bankname')">{{ errors.first("supplier_bankname") }}</span>
					</div>
					<!-- NAME -->
					<div class="mb-5" v-if="data.type == 2">
						<label for class="text-base vs-input--label"> Chủ tài khoản: </label>
						<cbs-input v-model="supplier_bankowner" class="w-full" name="supplier_bankowner" :data-vv-as="'Chủ tài khoản'" :placeholder="`${$t('Input')} ${'Chủ tài khoản'}`" />
						<span class="text-danger text-sm break-normal" v-show="errors.has('supplier_bankowner')">{{ errors.first("supplier_bankowner") }}</span>
					</div>
				</div>
				<!-- NAME -->
				<div class="mb-5">
					<label for class="text-base vs-input--label"> Địa chỉ: </label>
					<cbs-input v-model="address" class="w-full" name="address" :data-vv-as="'Địa chỉ'" :placeholder="`${$t('Input')} ${'Địa chỉ'}`" />
					<span class="text-danger text-sm break-normal" v-show="errors.has('address')">{{ errors.first("address") }}</span>
				</div>
				<!-- NAME -->
				<div class="mb-5">
					<label for class="text-base vs-input--label"> Ghi chú: </label>
					<cbs-input v-model="cus_note" class="w-full" name="cus_note" :data-vv-as="'Ghi chú'" :placeholder="`${$t('Input')} ${'Ghi chú'}`" />
					<span class="text-danger text-sm break-normal" v-show="errors.has('cus_note')">{{ errors.first("cus_note") }}</span>
				</div>
				<!-- NAME -->
				<div class="mb-5" v-if="data.type == 2">
					<label for class="text-base vs-input--label"> Hình ảnh thực tế: </label>
					<cbs-upload-ref
						:key="timeKey"
						value="value"
						v-model="localAttachFile"
						accept="image/*"
						:limit="10"
						:on-exceed="() => $vs.notify({ title: $t('Notify.Notification'), text: $t('OnlyOneFileUpload') })"
					/>
					<span class="text-danger text-sm break-normal" v-show="errors.has('address')">{{ errors.first("address") }}</span>
				</div>
			</div>
		</PerfectScrollbar>

		<div class="flex justify-center" slot="footer">
			<vs-button class="w-full sm:w-1/3 font-bold" @click.stop="submitData" >{{ id ? "Sửa lệnh" : (data.type == 1 ? "Đặt mua" : "Đặt bán") }}</vs-button>
		</div>
	</el-dialog>
</template>
<script>
import * as _ from "lodash";
import vSelect from "vue-select";
import SelectAssigned from "@/components/select-assigned/SelectAssigned";
import CbsUploadRef from "@/components/cbs-upload-ref/CbsUploadRef";

export default {
	name: "CustomerForm",
	components: { vSelect, SelectAssigned, CbsUploadRef },
	props: {
		isPopupActive: {
			type: Boolean,
			// required: true,
		},
		data: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			timeKey: Date.now(),
			supplier: null,
		};
	},
	watch: {
		isPopupActive(val) {
			if (!val) return;

			this.isFormDirty = false;
			this.initFormData = {};
		},

		computedFormData: {
			handler: function (newVal) {
				// if (!this.isFormDirty && !_.isEqual(newVal, this.initFormData) && newVal.id === this.initFormData.id) {
				// 	this.isFormDirty = true;
				// }
			},
			deep: true,
		},
		city() {
			if (this.city) {
				this.$store.dispatch("getDistrict", {
					provinceCode: this.city,
				});
			}
		},
		district() {
			if (this.district) {
				this.$store.dispatch("getWard", {
					districtCode: this.district,
				});
			}
		},
	},
	computed: {
		isPopupActiveLocal: {
			get() {
				return this.isPopupActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closePopup");
				}
			},
		},
		computedFormData() {
			return {
				id: this.id,
				fullName: this.fullName,
				nickname: this.nickname,
				phone: this.phone,
				city: this.city,
				district: this.district,
				ward: this.ward,
				street: this.street,
				assigned: this.assigned,
				totalPool: this.totalPool,
			};
		},
	},
	created() {
		// this.getSuppliers();
		let {id} = this.$route.params;
		this.id = id;
	},
	methods: {
		getSuppliers() {
			// this.$vs.loading();
			try {
				let payload = {
				};
				this.$store.dispatch("moduleProduct/fetchSuppliers", payload);
				this.getGetUsers();
				// this.$vs.loading.close();
			} catch (error) {
				console.log(error.message);
				// this.$vs.loading.close();
			}
		},
		handleChangeFile(uploadedFiles) {
			console.log('handleChangeFile: ', uploadedFiles);
			const uploadResult = uploadedFiles.map(file =>
				_.get(file, "response")
					? {
							id: file.response.id,
							path: file.response.path,
							file_name: file.response.file_name,
							extension: file.response.extension
					  } // eslint-disable-line no-mixed-spaces-and-tabs
					: file
			);

			this.value.attachFile = uploadResult && uploadResult.length ? uploadResult[0] : null;
		},
		initValues() {
			this.localAttachFile = [];
			this.timeKey = Date.now();
			this.quantity = null;
			this.price = null;
			this.supplier_name = null;
			this.supper_phone = null;
			this.supper_mst = null;
			this.supplier_bankaccount = null;
			this.supplier_bankname = null;
			this.supplier_bankowner = null;
			this.address = null;
			this.supplier = null;
			this.cus_note = null;
			this.$validator.reset();
		},
		submitData() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					const dataObj = {
						type: this.data.type,
						productId: this.product,
						supplierId: this.supplier,
						cus_note: this.cus_note,
						quantity: this.quantity,
						price: this.price,
						address: this.address,
						'supplier_name': this.supplier_name,
						'supper_phone': this.supper_phone,
						'supper_mst': this.supper_mst,
						'supplier_bankaccount': this.supplier_bankaccount,
						'supplier_bankname': this.supplier_bankname,
						'supplier_bankowner': this.supplier_bankowner,
						id: this.id,
						photos: this.files.map(item => item.id),
					};
					console.log("[SUBMIT]", dataObj);

					this.handleCreateOrUpdate(dataObj);
				}
			});
		},
		handleCreateOrUpdateSuccess() {
			if (this.supplier == 0) {
				this.getSuppliers();
			}
			if (!this.id) {
				this.initValues();
			}
			// if (this.id) {
			// 	this.$emit("closePopup");
			// }
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: "Đặt lệnh thành công",
				},
			});
		},
		async handleCreateOrUpdate(dataObj) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("moduleProduct/createOrder", dataObj);
				this.handleCreateOrUpdateSuccess();
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},

		getAddressCodeAndName(listData, code) {
			return _.find(listData, function (add) {
				return add.code === code;
			});
		},
	},
};
</script>
